<template>
    <div class="container" :class="size">
        <img src="../assets/img/empty/empty.png" alt="" class="img-404"  v-if="type === 0">
        <div class=" tips text-black text-sm margin-top-sm">{{tip}}</div>
    </div>
</template>

<script>
    export default {
        name: "Empty",
        data() {
            return {}
        },
        props: {
            type: {
                type: Number,
                default: 0
            },
            tip: {
                type: String,
                default: '暂无数据'
            },
            size: {
                type: String,
                default: ''
            },
        },
        computed: {},
        components: {},
    }
</script>

<style scoped lang="scss">
    .container {
        width: 50%;
        height: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #ffffff;

        &.min{
            height: auto!important;
            .tips{
                font-size: 14px;
            }
            .img-404{
                width: 100px;
            }
        }
        .img-404 {
            width: 50%;
            margin-top: 30px;
        }

        .go-home {
            width: 109px;
            height: 40px;
            margin-top: 30px;
            background-color: #ff6b54;
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            color: #ffffff;
            cursor: pointer;
        }
    }
</style>